// extracted by mini-css-extract-plugin
module.exports = {"container":"process_container__7_E7L","animationPlaceholder":"process_animationPlaceholder__P0tuu"};